import React from 'react';
import GameCard from './GameCard';

const Home = () => {
  const games = [
    {
      id: 'tic-tac-toe',
      title: 'Tic Tac Toe',
      icon: '⭕',
      description: 'Classic 3x3 grid game'
    },
    {
      id: 'snake',
      title: 'Snake Game',
      icon: '🐍',
      description: 'Eat food and grow longer'
    },
    {
      id: 'brick-breaker',
      title: 'Brick Breaker',
      icon: '🧱',
      description: 'Break all the bricks'
    },
    {
      id: 'tetris',
      title: 'Tetris',
      icon: '🟦',
      description: 'Stack falling blocks'
    },
    {
      id: 'pacman-chase',
      title: 'Pacman Chase',
      icon: '👻',
      description: 'Avoid the ghosts'
    },
    {
      id: 'maze-solver',
      title: 'Maze Solver',
      icon: '🌀',
      description: 'Navigate through the maze'
    },
    {
      id: 'dots-and-boxes',
      title: 'Dots and Boxes',
      icon: '⬜',
      description: 'Connect dots to make boxes'
    },
    {
      id: 'checkers',
      title: 'Checkers',
      icon: '🔴',
      description: 'Classic board game'
    },
    {
      id: 'memory-game',
      title: 'Memory Game',
      icon: '🃏',
      description: 'Match pairs of cards'
    },
    {
      id: 'rock-paper-scissors',
      title: 'Rock Paper Scissors',
      icon: '✂️',
      description: 'Beat the computer'
    },
    {
      id: 'whack-a-mole',
      title: 'Whack-a-Mole',
      icon: '🔨',
      description: 'Hit the moles quickly'
    },
    {
      id: 'math-quiz',
      title: 'Math Quiz',
      icon: '🧮',
      description: 'Solve arithmetic problems'
    },
    {
      id: 'number-guessing',
      title: 'Number Guessing',
      icon: '🎯',
      description: 'Guess the secret number'
    },
    {
      id: 'color-matching',
      title: 'Color Matching',
      icon: '🎨',
      description: 'Match the colors'
    },
    {
      id: 'typing-speed',
      title: 'Typing Speed',
      icon: '⌨️',
      description: 'Test your typing speed'
    },
    {
      id: '2048',
      title: '2048',
      icon: '🔢',
      description: 'Combine tiles to reach 2048'
    },
    {
      id: 'sudoku',
      title: 'Sudoku',
      icon: '🔢',
      description: 'Fill the 9x9 grid with numbers'
    },
    {
      id: 'sliding-puzzle',
      title: 'Sliding Puzzle',
      icon: '🧩',
      description: 'Arrange tiles in order'
    },
    {
      id: 'lights-out',
      title: 'Lights Out',
      icon: '💡',
      description: 'Turn off all the lights'
    },
    {
      id: 'connect-four',
      title: 'Connect Four',
      icon: '🔴',
      description: 'Get four in a row'
    },
    {
      id: 'minesweeper',
      title: 'Minesweeper',
      icon: '💣',
      description: 'Find all the mines'
    },
    {
      id: 'nonogram',
      title: 'Nonogram',
      icon: '⬛',
      description: 'Reveal the hidden picture'
    },
    {
      id: 'tower-of-hanoi',
      title: 'Tower of Hanoi',
      icon: '🗼',
      description: 'Move all disks to the right'
    },
    {
      id: 'match3',
      title: 'Match-3',
      icon: '💎',
      description: 'Match three or more gems'
    },
    {
      id: 'word-search',
      title: 'Word Search',
      icon: '🔍',
      description: 'Find hidden words in the grid'
    },
    {
      id: 'flappy-bird',
      title: 'Flappy Bird',
      icon: '🐦',
      description: 'Fly through the pipes'
    },
    {
      id: 'space-shooter',
      title: 'Space Shooter',
      icon: '🚀',
      description: 'Shoot down alien invaders'
    },
    {
      id: 'asteroids',
      title: 'Asteroids',
      icon: '☄️',
      description: 'Destroy asteroids in space'
    },
    {
      id: 'pong',
      title: 'Pong',
      icon: '🏓',
      description: 'Classic paddle game'
    },
    {
      id: 'breakout-advanced',
      title: 'Breakout Advanced',
      icon: '🧱',
      description: 'Break bricks with power-ups'
    },
    {
      id: 'aim-trainer',
      title: 'Aim Trainer',
      icon: '🎯',
      description: 'Click targets quickly'
    },
    {
      id: 'reaction-time',
      title: 'Reaction Time',
      icon: '⚡',
      description: 'Test your reflexes'
    },
    {
      id: 'pattern-memory',
      title: 'Pattern Memory',
      icon: '🎵',
      description: 'Simon Says game'
    },
    {
      id: 'shape-sorter',
      title: 'Shape Sorter',
      icon: '🎨',
      description: 'Drag and drop shapes'
    },
    {
      id: 'ball-avoider',
      title: 'Ball Avoider',
      icon: '⚽',
      description: 'Dodge moving obstacles'
    }
  ];

  return (
    <div className="home-container">
      <h1 className="home-title">🎮 Mini Game Hub</h1>
      <div className="games-grid">
        {games.map(game => (
          <GameCard key={game.id} game={game} />
        ))}
      </div>
    </div>
  );
};

export default Home;